
export const initialState = {
  loading: false,
  error: undefined,
  encounters: []
};

export function encounterReducer(state = initialState, action = undefined) {
  switch(action.type){
    case "ENCOUNTER_ADD_REQUEST":
    case "ENCOUNTERS_LIST_REQUEST":
      return {
        ...state,
        loading : true,
      }
    case "ENCOUNTER_ADD_SUCCESS": {
      return {
        ...state,
        loading: false,
        encounters: addOrRetrieveList(state.encounters, action.encounter),
      }
    }
    case "ENCOUNTER_ADD_FAILURE":
    case "ENCOUNTER_LIST_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    case "ENCOUNTER_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        encounters: action.encounters,
      }
    }
    default:
      return state;
  }
}

 
function addOrRetrieveList(list, element) {
  const presetEncounterIndex = list.findIndex(el => el.id === element.id);
  // The encounter was already in the list, so we need to just replace it.
  if (presetEncounterIndex !== -1) {
    const newList = [...list];
    newList.splice(presetEncounterIndex, 1, element);
    return newList;
  }
  // The encounter is not part of the list, push it!
  return list.concat(element);
}